import { render } from "./wzselect.vue?vue&type=template&id=2b607448&scoped=true"
import script from "./wzselect.vue?vue&type=script&lang=js"
export * from "./wzselect.vue?vue&type=script&lang=js"

import "./wzselect.vue?vue&type=style&index=0&id=2b607448&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b607448"]])

export default __exports__